import React, { useEffect, useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import {
  getReturnRequests,
  approveReturnRequests,
  rejectReturnRequests,
} from "store/return-request/return-request-action"
import { returnRequestAction } from "store/return-request/return-request-slice"
import ReturnRequestListComponent from "components/ReturnRequest/list"

const ReturnRequestsList = () => {
  document.title = "Returns Management"

  const dispatch = useDispatch()
  const { data, loading, adminNote } = useSelector(state => state.returnRequest)
  const [pageNumber, setPageNumber] = useState(10)
  const [selectedIds, setSelectedIds] = useState([])

  useEffect(() => {
    dispatch(getReturnRequests(pageNumber))
  }, [pageNumber])

  const onPageClick = () => {
    dispatch(getReturnRequests(pageNumber))
  }

  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  const handleCheckboxChange = (id, checked) => {
    if (checked) {
      setSelectedIds([...selectedIds, id])
    } else {
      setSelectedIds(selectedIds.filter(selectedId => selectedId !== id))
    }
  }

  const handleSelectAll = checked => {
    if (checked) {
      const pendingIds =
        data?.data
          ?.filter(item => item.status === "Pending")
          .map(item => item.id) || []
      setSelectedIds(pendingIds)
    } else {
      setSelectedIds([])
    }
  }

  const handleApprove = () => {
    if (selectedIds.length === 0) return
    dispatch(
      approveReturnRequests(selectedIds, adminNote, success => {
        if (success) setSelectedIds([])
      })
    )
  }

  const handleReject = () => {
    if (selectedIds.length === 0) return
    dispatch(
      rejectReturnRequests(selectedIds, adminNote, success => {
        if (success) setSelectedIds([])
      })
    )
  }

  return (
    <div className="page-content">
      <Breadcrumbs title="Returns Management" breadcrumbItem="Returns Management" />
      <ReturnRequestListComponent
        data={data}
        loading={loading}
        onPageClick={onPageClick}
        onChangeRowNumber={onChangeRowNumber}
        selectedIds={selectedIds}
        onCheckboxChange={handleCheckboxChange}
        onSelectAll={handleSelectAll}
        onApprove={handleApprove}
        onReject={handleReject}
        adminNote={adminNote}
        onAdminNoteChange={value =>
          dispatch(returnRequestAction.setAdminNote(value))
        }
      />
    </div>
  )
}

export default ReturnRequestsList
